import TranslationText from '@Components/Utilities/TranslationText';
import SpecList from '@Components/Shared/Specs/SpecList';
import CompareDealerButtons from '@Components/Compare/CompareDealerButtons';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { forwardRef } from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { loadable } from '@Components/Utilities/SandhillsLoadable';
import { LinkRelationTypes } from '@Components/Utilities/SandhillsConstants';
import translator from '@Components/Utilities/Translator';

const LowerDetailPricing = loadable(() => import('@Components/Detail/LowerDetailPricing'));

const CompareListing = forwardRef((props, ref) => {


    const openEmailModal = () => {
        props.openEmailModal({
            ModalTitle: props.Title,
            Subject: props.Title,
            DealerCRMID: props.DealerCRMID,
            DealerGroupID: props.DealerGroupID,
            BranchName: props.Dealer || '',
            ListingManufacturer: props.ManufacturerName,
            ListingModel: props.Model,
            ListingBaseCatID: props.BaseCategoryId,
            ListingCategoryID: props.CategoryId,
            ListingID: props.Id,
            ListingSourceDomainUrl: props.ListingSourceDomainUrl,
            SerialNumber: props.SerialNumber || '',
            Price: props.RetailPrice || '',
            WholeSalePrice: props.WholeSalePrice,
            ListingURL: props.DetailUrl,
            IsParts: false,
            IsExclusiveWholeSale: props.IsExclusiveWholeSale,
            ListingCondition: props.Condition,
            UseLeadsUXUpdate: true,
            Ref: ref.current[props.Id]
        });
    };

    return (
        <div className='compare-container' id={props.Id}>
            <div className='comp-header-img'>
                <div className='comp-title-close-cont'>
                    <span className='compare-title'><h2>{props.Title}</h2></span>
                    <div role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); props.DeleteListing(props.Id); } }} aria-label={translator.translate('sandhills.tradepubwebsite.mvc.deletelisting') } className='compare-close' onClick={() => props.DeleteListing(props.Id)}><i className='fas fa-times' aria-hidden='True' /></div>
                </div>
                <LazyLoadImage src={props.ImageUrl} className='compare-img' alt={props.Title ? props.Title : "" } />
            </div>
            <div className='list-media'>
                {props.ImageCount > 0 &&
                    <span>
                        <span className='media-icon'>
                            <img src={props.ImageIconUrl} alt='Images'/>
                        </span>
                        <span className='media-icon-text'>{props.ImageCount}</span>
                    </span>}
                {props.VideoCount > 0 &&
                    <span>
                        <span className='media-icon'>
                            <img src={props.VideoIconUrl} alt="" />
                        </span>
                        <span className='media-icon-text'>{props.VideoCount}</span>
                    </span>}
            </div>
            {(props.UnauthorizedAuctionResultRequest) ?
                <div style={{ textAlign: 'center' }}>
                    <div style={{ marginBottom: '10px', fontSize: '14px' }}><strong><TranslationText tKey='sandhills.loginorregistertoviewauctionresults' /></strong></div>
                    <Grid container spacing={1} sx={{ justifyContent: 'center' }}>
                        <Button
                            style={{ textDecoration: 'none' }}
                            variant='contained'
                            sx={{ color: 'white', width: '100%', height: '36px', margin: '5px', textTransform: 'capitalize' }}
                            onClick={() => { window.location.href = props.LoginLink }}
                            rel={LinkRelationTypes.noFollow}>
                            <TranslationText tKey='sandhills.sso.website.login' />
                        </Button>
                        <Button
                            style={{ textDecoration: 'none' }}
                            variant='contained'
                            sx={{ color: 'white', width: '100%', height: '36px', margin: '5px' }}
                            onClick={() => { window.location.href = props.RegistrationLink }}
                            rel={LinkRelationTypes.noFollow}>
                            <TranslationText tKey='sandhills.tradepubwebsite.mvc.register' />
                        </Button>
                    </Grid>
                </div>
                :
                <>
                    {props.PricingInfo ?
                        <div className='compare-price'>
                            <LowerDetailPricing {...props.PricingInfo} IsRY={true} />
                        </div> :
                        <>
                            <span className='compare-price'>{props.DisplayPriceInclusiveTax && props.RetailPriceWithTax ? props.RetailPriceWithTax : props.RetailPrice}</span>
                            <div className='compare-specs'>
                                <div className='cs-row'>
                                    {props.RetailPriceWithTax &&
                                        <>
                                            <span className='cs-spec'>{props.RetailPrice} + {props.TaxRateType} = {props.RetailPriceWithTax}</span>
                                            <span className='cs-spec'> ({props.TaxAppliesInTranslatedText})</span>
                                        </>}
                                    {props.RetailPriceWithoutTax &&
                                        <>
                                            <span className='cs-spec'>{props.RetailPriceWithoutTax} + {props.TaxRateType} = {props.RetailPrice}</span>
                                            <span className='cs-spec'> ({props.TaxAppliesInTranslatedText})</span>
                                        </>}
                                    {props.TaxNotApplicable &&
                                        <span className='cs-spec'>{props.TaxAppliesInTranslatedText}</span> }
                                </div>       
                            </div>
                        </>
                    }
                    {props.FormattedLocation &&
                        <div className='compare-specs'>
                            <div className='cs-row'>
                                <span className='cs-spec'>{props.FormattedLocation}</span>
                            </div>
                        </div>}
                    <div className='compare-specs'>
                        {props.Specs.map((obj, i) =>
                            <SpecList {...obj} key={i} RowClassName='cs-row' />)}
                    </div>
                    <div className='dealer-btns-bottom'>
                        <CompareDealerButtons
                            DetailUrl={props.DetailUrl}
                            MessageUrl={props.MessageSellerUrl}
                            DetailLinkTarget={props.DetailLinkTarget}
                            UnformattedPhoneNumber={props.UnformattedPhoneNumber}
                            PhoneType={props.PhoneType}
                            IsRetailPhoneNumberTextEnabled={props.IsRetailPhoneNumberTextEnabled}
                            ShowSendAMessage={props.ShowSendAMessage}
                            WhatsAppLink={props.WhatsAppLink}
                            FBMessengerLink={props.FBMessengerLink}
                            FBMessengerImageUrl={props.FBMessengerImageUrl}
                            ShowPhoneAndTextOption={props.ShowPhoneAndTextOption}
                            TextMessageBody={props.TextMessageBody}
                            openEmailModal={openEmailModal}
                            ref={ref}
                            ID={props.Id}
                            IsForRentOnly={props.IsForRentOnly}
                            IsRY={props.IsRY}
                        />
                    </div>
                </>}
        </div>
    );
});

export default CompareListing;